import {Account,} from '../types';
import {
    PlatformPropertyCard,
    PlatformPropertyCardCopyButtonDecorator,
} from '@flexinet/ui-components';
import {AccountStatusBadge} from './AccountStatusBadge';
import {AccountTypeBadge} from "./AccountTypeBadge.tsx";


export const Profile = ({record}: { record: Account }) => {

    // FNP-575: the Billing section (Customer linkage / Create Customer) moved out of
    // this left-hand Profile into its own Billing tab (see EditPage + BillingTab).

    const properties = [
        {
            kind: 'section' as const,
            label: 'Identity',
            description: 'Cognito identity and account classification',
        },
        {
            label: 'Email',
            value: record.email as string,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 12,
        }, {
            label: 'Sub',
            value: record.sub as string,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 12,
        }, {
            label: 'Username',
            value: record.username as string,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 12,
        }, {
            label: 'Account Type',
            value: <AccountTypeBadge record={record}/>,
            span: 12,
        }, {
            label: 'Status',
            value: <AccountStatusBadge record={record}/>,
            span: 12,
        },
        {
            kind: 'section' as const,
            label: 'Audit',
            description: 'Creation, ownership, and last update metadata',
        },
        {
            label: 'Created By',
            value: typeof record.createdBy !== 'undefined' && record.createdBy !== null ? [record.createdBy.givenName, record.createdBy.familyName].join(' ') : 'n/a',
            rbac: 'CreateAccount',
            span: 12,
        },
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        }, {
            label: 'Managed By',
            value: typeof record.managedBy !== 'undefined' && record.managedBy !== null ? [record.managedBy.givenName, record.managedBy.familyName].join(' ') : 'n/a',
            rbac: 'UpdateAccount',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        },
    ];

    return (
        <PlatformPropertyCard properties={properties}/>
    );


};
